import { Inject, Injectable, TemplateRef } from '@angular/core';
import { MenuViewModel } from '@app/shared/components/menu/menu.component';
import { FocusStackService } from '@app/shared/services/focus-stack.service';
import { TargetService } from '@app/target/services/target.service';
import { Target } from '@app/target/target-api.model';
import { TranslateService } from '@ngx-translate/core';
import { finalize, tap } from 'rxjs/operators';
import { WindowToken } from '@app/shared/window.token';
import { AuthService } from '@dg/shared-services';

@Injectable({
  providedIn: 'root',
})
export class FlexViewHeaderMenuService {
  public i18n = this.translate.instant(['Core_Delete', 'Core_Settings']);

  constructor(
    private focusStackService: FocusStackService,
    private targetService: TargetService,
    private translate: TranslateService,
    private authService: AuthService,
    @Inject(WindowToken) private windowRef: Window
  ) {}

  public getSettingsMenuConfig(target: Target, context: string) {
    const settingsMenu: MenuViewModel[] = [
      {
        id: 'settings',
        title: this.i18n.Core_Settings,
        defaultAction: (_, popoverTrigger) =>
          this.editTarget(target, context, popoverTrigger.nativeElement),
        isHidden: () => false,
      },
      {
        id: 'delete',
        title: this.i18n.Core_Delete,
        defaultAction: (_, popoverTrigger) =>
          this.deleteTarget(target, context, popoverTrigger.nativeElement),
        isHidden: () => target.targetType === 'Browse',
      },
    ];
    return settingsMenu;
  }

  private deleteTarget(
    target: Target,
    context: string,
    returnFocusToEl: HTMLElement
  ) {
    this.targetService
      .showTargetDeleteModal({
        targetTitle: target.title,
        target: target,
        sourceEventTarget: returnFocusToEl,
      })
      .pipe(
        finalize(() => {
          this.focusStackService.push(returnFocusToEl);
          this.focusStackService.pop();
        })
      )
      .subscribe(() => {
        const vanityUrl = this.authService.authUser.viewerProfile.vanityUrl;
        let returnUrl = `/${vanityUrl}/dashboard/plans`;
        if (context === 'channel') {
          returnUrl = '/channel/catalog/plans';
        }
        // Consider using angular router here
        this.windowRef.open(returnUrl, '_self');
      });
  }

  private editTarget(
    target: Target,
    context: string,
    returnFocusToEl: HTMLElement
  ) {
    this.targetService
      .showTargetModal({
        target: target,
        context: context,
        loadTarget: true,
        mode: 'edit',
      })
      .pipe(
        finalize(() => {
          this.focusStackService.push(returnFocusToEl);
          this.focusStackService.pop();
        })
      )
      .subscribe();
  }
}
